// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "global." + {"301":"ed5ad59bdc13edefb918","665":"ecab68371c26decce669"}[chunkId] + ".js";
};